import styled from 'styled-components';
import Heading from '/components/ui/typography/Heading';
import Paragraph from '/components/ui/typography/Paragraph';
import Button from '/components/ui/buttons/Button';
import { colors } from '/css';
import Container from '/components/Container';
import { JobTemplate, JobTemplateType } from '/types/jobTemplateTypes';
import usePostCodeState from '/hooks/usePostCodeState';
import useIsJobSupported from '/hooks/useIsJobSupported';
import ResourceType from '/types/resourceType';

interface Props {
    jobType: JobTemplate['typeKey'];
}

export default function CoverageInfo({ jobType }: Props) {
    const {
        postCode,
        postCodeValid,
        postCodeNotificationRequest,
        postCodeSupportedJobTypes,
    } = usePostCodeState();

    const isJobSupported = useIsJobSupported({
        resourceType: ResourceType.CART,
    });

    if (!!postCode && (postCodeValid === false || !isJobSupported(jobType))) {
        return (
            <NoCoverage className="pt-48 pb-48">
                <Container small>
                    <Heading size="medium" className="mb-8-all">
                        Beklager, denne jobben er ikke lansert i ditt område
                        enda.
                    </Heading>
                    {postCodeNotificationRequest ? (
                        <Paragraph size="medium">
                            Takk for din interesse, vi holder deg informert på
                            e-post.
                        </Paragraph>
                    ) : (
                        <>
                            <Paragraph size="medium" className="mb-32">
                                Få varsel på e-post når vi utvider.
                            </Paragraph>
                            <Button
                                link="/nyhetsbrev"
                                className="mr-24"
                                size="medium"
                            >
                                Skriv deg på venteliste
                            </Button>
                            <Button
                                size="medium"
                                variant="tertiary"
                                link="/nettbutikk/alle"
                            >
                                Se alle jobber
                            </Button>
                        </>
                    )}
                </Container>
            </NoCoverage>
        );
    }

    if (
        !!postCode &&
        postCodeValid &&
        jobType === 'HEAT_PUMP' &&
        isJobSupported(jobType) &&
        !postCodeSupportedJobTypes.includes(JobTemplateType.ELECTRICIAN)
    ) {
        return (
            <ElectricianJobsAvailable className="pt-48 pb-48">
                <Container small>
                    <Heading size="medium" className="mb-8-all">
                        Andre behov for elektriker?
                    </Heading>
                    <Paragraph>
                        Når du legger varmepumpen i handlekurven, kan du også
                        bestille vanlige elektrikerjobber i samme slengen, siden
                        elektrikeren allerede kommer til deg.
                    </Paragraph>
                </Container>
            </ElectricianJobsAvailable>
        );
    }

    return null;
}

const NoCoverage = styled.div`
    background: ${colors.purpleM6};
    @media (max-width: 767px) {
        a {
            &:first-of-type {
                margin-right: 0;
                margin-bottom: 12px;
            }
            width: 100%;
        }
    }
`;

const ElectricianJobsAvailable = styled.div`
    background: ${colors.purpleM6};
`;
